import { useState } from 'react';
import { useTranslation } from '../../i18n';

const NODE_TYPES = ['topics', 'platforms', 'formats', 'people', 'partners', 'locations', 'hashtags', 'gaps'];

const NODE_COLOURS = {
  topics:    'var(--f8m-terra)',
  platforms: 'var(--f8m-navy)',
  formats:   'var(--f8m-caramel)',
  people:    'var(--f8m-sage)',
  partners:  'var(--f8m-olive)',
  locations: 'var(--f8m-sky)',
  hashtags:  'var(--f8m-gold)',
  gaps:      'var(--f8m-orange)',
};

export function ContentMapPage() {
  const { t } = useTranslation();
  const [enabled, setEnabled] = useState(new Set(NODE_TYPES));

  function toggle(type) {
    setEnabled((prev) => {
      const next = new Set(prev);
      if (next.has(type)) next.delete(type);
      else next.add(type);
      return next;
    });
  }

  return (
    <div>
      <header className="page-header">
        <h1 className="page-header__title">{t('contentMap.title')}</h1>
        <div className="page-header__subtitle">{t('contentMap.subtitle')}</div>
      </header>

      <div className="map-toolbar" role="group" aria-label={t('contentMap.filtersLabel')}>
        <span className="map-toolbar__label">{t('contentMap.filtersLabel')}</span>
        {NODE_TYPES.map((type) => {
          const isOn = enabled.has(type);
          return (
            <button
              key={type}
              type="button"
              aria-pressed={isOn}
              className={'filter-pill' + (isOn ? ' filter-pill--active' : '')}
              onClick={() => toggle(type)}
            >
              <span
                aria-hidden="true"
                style={{
                  display: 'inline-block',
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  background: NODE_COLOURS[type],
                  marginRight: 6,
                  verticalAlign: 'middle',
                }}
              />
              {t(`contentMap.nodeTypes.${type}`)}
            </button>
          );
        })}
      </div>

      <div className="map-layout">
        <div className="map-canvas">
          <div className="map-canvas__icon" aria-hidden="true">🕸</div>
          <h2>{t('contentMap.placeholderTitle')}</h2>
          <p>{t('contentMap.placeholderBody')}</p>
        </div>

        <aside className="map-side">
          <h3 className="map-side__title">{t('contentMap.panelTitle')}</h3>
          <p className="map-side__hint">{t('contentMap.panelHint')}</p>
        </aside>
      </div>
    </div>
  );
}
